export const EXCHANGES = 'EXCHANGES'
export const DEFI = 'DEFI'
export const MARKETPLACES = 'MARKETPLACES'
export const COLLECTIBLES = 'COLLECTIBLES'
export const GAMES = 'GAMES'
export const SOCIAL_NETWORKS = 'SOCIAL_NETWORKS'
export const UTILITIES = 'UTILITIES'
export const CRYPTO_ONRAMPS = 'CRYPTO_ONRAMPS'
export const OTHER = 'OTHER'
